// axiosInstance.ts
import axios from "axios";
import { setGlobalLoading } from "./loadingBridge"; // we’ll make this next
import { toast } from 'react-toastify';

const token = localStorage.getItem('token');
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        Authorization: token ? `Bearer ${token}` : '',
    },
});

let isLoggingOut = false;

// Interceptor to handle 401 globally
axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const status = error.response?.status;

        if (status === 401 && !isLoggingOut) {
            isLoggingOut = true;

            try {
                // Call your logout API
                await axiosInstance.post('/signout');

                // Optionally remove token
                localStorage.removeItem('token');
                localStorage.removeItem("email");
                localStorage.removeItem("type");
                localStorage.removeItem("name");

                // Redirect to login page
                window.location.href = '/login';
            } catch (logoutError) {
                console.error('Logout failed:', logoutError);
                window.location.href = '/login'; // Redirect anyway
            }
        } else {
            // Show toast for other errors
            const message =
                error.response?.data?.details?.error?.message || error.response?.data?.message ||
                error.message ||
                'An unexpected error occurred';

            setTimeout(() => {
                toast.error(message);
            }, 0);
        }
        return Promise.reject(error);
    }
);
// Request interceptor — show loader
axiosInstance.interceptors.request.use(
    (config) => {
        setGlobalLoading(true);
        return config;
    },
    (error) => {
        setGlobalLoading(false);
        return Promise.reject(error);
    }
);

// Response interceptor — hide loader
axiosInstance.interceptors.response.use(
    (response) => {
        setGlobalLoading(false);
        return response;
    },
    (error) => {
        setGlobalLoading(false);
        return Promise.reject(error);
    }
);

export default axiosInstance;
